import { useEffect, Fragment } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { Badge } from 'react-bootstrap';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { formatNumber, sortTableDateFecha, sortTableDateFechaInicio } from '../../utils/generalFunctions';

import { setAlert } from '../../actions/alert';
import { editarBreadcrumb } from '../../actions/breadcrumb';
import { informacionAsesoria, statusAsesoria, limpiarAsesoria, limpiarContacto, limpiarNota, detallesArchivo, limpiarArchivo, detallesAhorro, limpiarAhorro } from '../../actions/asesorias';

import NuevoContacto from './NuevoContacto';
import NuevaNota from './NuevaNota';
import NuevoArchivo from './NuevoArchivo';
import EditarContacto from './EditarContacto';
import EditarNota from './EditarNota';
import EditarArchivo from './EditarArchivo';
import EliminarContacto from './EliminarContacto';
import EliminarNota from './EliminarNota';
import EliminarArchivo from './EliminarArchivo';
import NuevoAhorro from './NuevoAhorro';
import EditarAhorro from './EditarAhorro';
import EliminarAhorro from './EliminarAhorro';
import FinalizarAsesoria from './FinalizarAsesoria';

const DetallesAsesoria = () => {

    let rutasBread = [
        {
            activo: false,
            nombre: 'Asesorías',
            path: '/asesorias'
        },
        {
            activo: true,
            nombre: 'Detalles de la asesoría',
            path: '/asesorias/detalles/'
        }
    ];

    const dispatch = useDispatch();

    const { id } = useParams();

    const { usuario } = useSelector(state => state.auth);
    const { detalles, detalles_archivo, detalles_ahorro } = useSelector(state => state.asesorias);

    /* Cliente */
    const [asesoriaData, setAsesoriaData] = useState({
        indicadores_generales: {
            contactos: 0,
            notas: 0,
            archivos: 0,
            ahorros: 0,
            status: null
        },
        informacion_asesoria: {
            _id: null,
            motivo: null,
            descripcion : null,
            creacion: null,
            finalizacion: null,
            status: null
        },
        informacion_cliente: {
            _id: null,
            nombre: null,
            apellido_paterno: null,
            apellido_materno: null,
            nacimiento : null,
            celular: null,
            email: null,
            creacion: null,
            status: false, 
            empresa: {
                nombre_comercial: null, 
                razon_social: null, 
                rfc: null, 
                curp: null, 
                curp: null, 
                tipo_persona: null, 
                regimen_fiscal: null, 
                giro: null, 
                representante_legal: null, 
                puesto: null, 
                domicilio_fiscal: null, 
                telefono: null, 
                email: null, 
                web: null, 
                fecha_constitucion: null, 
                numero_empleados: null, 
                minimo_ingresos_anuales: null, 
                maximo_ingresos_anuales: null
            },
        },
        contactos: [],
        notas: [],
        archivos: [],
        ahorros: [],
        solicitud_wa: null
    });

    /* Contactos */
    const [nuevoContacto, setNuevoContacto] = useState({
        asesoria: null
    });
    const [editarContacto, setEditarContacto] = useState(null);
    const [eliminarContacto, setEliminarContacto] = useState(null);

    /* Notas */
    const [nuevaNota, setNuevaNota] = useState({
        asesoria: null
    });
    const [editarNota, setEditarNota] = useState(null);
    const [eliminarNota, setEliminarNota] = useState(null);

    /* Archivos */
    const [nuevoArchivo, setNuevoArchivo] = useState({
        asesoria: null
    });
    const [editarArchivo, setEditarArchivo] = useState(null);
    const [eliminarArchivo, setEliminarArchivo] = useState(null);

    /* Ahorros */
    const [nuevoAhorro, setNuevoAhorro] = useState({
        asesoria: null
    });
    const [editarAhorroData, setEditarAhorroData] = useState(null);
    const [eliminarAhorroData, setEliminarAhorroData] = useState(null);

    const [asesoriaFinalizar, setAsesoriaFinalizar] = useState(null);

    const {indicadores_generales, informacion_asesoria, informacion_cliente, contactos, notas, archivos, ahorros, solicitud_wa} = asesoriaData;

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const contactosColumnas = [
        {
            name: 'Asesor',
            sortable: true, 
            selector: row => row.asesor ? [row.asesor.nombre, row.asesor.apellido_paterno, row.asesor.apellido_materno].join(' ') : 'Sin definir', 
            grow: 2
        },
        {
            name: 'Tipo',
            sortable: true, 
            selector: row => {
                switch(row.tipo){
                    case 0:
                        return 'Correo';
                    case 1:
                        return 'Llamada';
                    case 2:
                        return 'WhatsApp';
                    case 3:
                        return 'Presencial';
                    default:
                        break;
                }
            }
        }, 
        {
            name: 'Observaciones',
            sortable: true, 
            selector: row => row.observaciones || 'Sin definir', 
            grow: 4
        },
        {
            name: 'Fecha',
            sortable: true, 
            sortFunction: sortTableDateFecha, 
            cell: item => item.fecha ? new Date(item.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(item.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir', 
            grow: 2
        },
        {
            name: '',
            grow: 1, 
            cell: row => {
                return(
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.asesorias?.historial?.eliminar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 && 
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarContacto({ id_asesoria: id, id_contacto: row._id, fecha: row.fecha ? new Date(row.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(row.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir' })}><i className="fas fa-times text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.asesorias?.historial?.editar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 && 
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarContacto({ id_asesoria: id, id_contacto: row._id, ...row })}><i className="fas fa-edit text-primary"></i></button>
                        }
                    </div>
                )
            }
        }
    ];

    const notasColumnas = [
        {
            name: 'Nota',
            sortable: true, 
            selector: row => row.contenido, 
            grow: 4
        },
        {
            name: 'Asesor',
            sortable: true, 
            selector: row => row.asesor ? [row.asesor.nombre, row.asesor.apellido_paterno, row.asesor.apellido_materno].join(' ') : 'Sin definir', 
            grow: 2
        },
        {
            name: 'Fecha',
            sortable: true, 
            sortFunction: sortTableDateFechaInicio, 
            cell: item => item.fecha ? new Date(item.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(item.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir', 
            grow: 2
        }, 
        {
            name: '',
            grow: 1, 
            cell: row => {
                return(
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.asesorias?.notas?.eliminar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 && 
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarNota({ id_asesoria: id, id_nota: row._id, fecha: row.fecha ? new Date(row.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })  + ' a las ' + new Date(row.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir' })}><i className="fas fa-times text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.asesorias?.notas?.editar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 && 
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarNota({ id_asesoria: id, id_nota: row._id, ...row })}><i className="fas fa-edit text-primary"></i></button>
                        }
                    </div>
                )
            }
        }
    ];

    const archivosColumnas = [
        {
            name: 'Nombre',
            sortable: true, 
            grow: 2, 
            selector: row => row.nombre || 'Sin definir'
        },
        {
            name: 'Descripción',
            sortable: true, 
            grow: 2, 
            selector: row => row.descripcion || 'Sin definir'
        },
        {
            name: 'Tipo',
            sortable: true, 
            selector: row => row.extension ? row.extension.toUpperCase() : 'Sin definir'
        },
        {
            name: 'Fecha de carga',
            sortable: true, 
            sortFunction: sortTableDateFecha, 
            cell: item => item.fecha ? new Date(item.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'
        }, 
        {
            name: '',
            grow: 1, 
            cell: row => {
                return(
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.asesorias?.archivos?.eliminar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 && 
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarArchivo({ id_asesoria: id, id_archivo: row._id, nombre: row.nombre })}><i className="fas fa-times text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.asesorias?.archivos?.editar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 && 
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarArchivo({ id_asesoria: id, id_archivo: row._id, ...row })}><i className="fas fa-edit text-primary"></i></button>
                        }
                        {
                            usuario?.permisos?.asesorias?.archivos?.detalles &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleDetallesArchivo({ id_asesoria: id, id_archivo: row._id })}><i className="fas fa-eye text-info"></i></button>
                        }
                    </div>
                )
            }
        }
    ];

    const TIPOS_AHORRO = {
        1: 'Comisiones bancarias',
        2: 'Tasa de interés',
        3: 'Seguros',
        4: 'Crédito',
        5: 'Otro'
    };

    const ahorrosColumnas = [
        {
            name: 'Tipo',
            sortable: true,
            selector: row => TIPOS_AHORRO[row.tipo] || 'Sin definir'
        },
        {
            name: 'Banco',
            sortable: true,
            selector: row => row.banco || 'Sin definir',
            grow: 2
        },
        {
            name: 'Monto anual',
            sortable: true,
            selector: row => row.monto_anual != null ? formatNumber(row.monto_anual, 2, '$', '') : 'Sin definir'
        },
        {
            name: 'Descripción',
            sortable: true,
            selector: row => row.descripcion || 'Sin definir',
            grow: 3
        },
        {
            name: 'Fecha',
            sortable: true,
            sortFunction: sortTableDateFecha,
            cell: item => item.fecha ? new Date(item.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'
        },
        {
            name: '',
            grow: 1,
            cell: row => {
                return (
                    <div className="text-right w-100">
                        {
                            usuario?.permisos?.asesorias?.ahorros?.eliminar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEliminarAhorro({ id_asesoria: id, id_ahorro: row._id, banco: row.banco })}><i className="fas fa-times text-danger"></i></button>
                        }
                        {
                            usuario?.permisos?.asesorias?.ahorros?.editar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleEditarAhorro({ id_asesoria: id, id_ahorro: row._id, ...row })}><i className="fas fa-edit text-primary"></i></button>
                        }
                        {
                            usuario?.permisos?.asesorias?.ahorros?.detalles && row.extension &&
                                <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleDetallesAhorro({ id_asesoria: id, id_ahorro: row._id })}><i className="fas fa-eye text-info"></i></button>
                        }
                    </div>
                )
            }
        }
    ];

    /* Contactos */
    const handleAgregarContacto = (asesoria) => {
        setNuevoContacto({
            asesoria
        });
    }

    const handleEditarContacto = (asesoria) => {
        setEditarContacto(asesoria);
    }

    const handleEliminarContacto = (asesoria) => {
        setEliminarContacto(asesoria);
    }

    /* Notas */
    const handleAgregarNota = (asesoria) => {
        setNuevaNota({
            asesoria
        });
    }

    const handleEditarNota = (asesoria) => {
        setEditarNota(asesoria);
    }

    const handleEliminarNota = (asesoria) => {
        setEliminarNota(asesoria);
    }

    /* Archivos */
    const handleAgregarArchivo = (asesoria) => {
        setNuevoArchivo({
            asesoria
        });
    }

    const handleDetallesArchivo = (archivo) => {
        dispatch(detallesArchivo(archivo));
    }

    const handleAbrirArchivo = () => {
        if(!editarArchivo){
            window.open(detalles_archivo.url, '_blank', 'noopener,noreferrer');
        }
    }

    const handleEditarArchivo = (asesoria) => {
        setEditarArchivo(asesoria);
    }

    const handleEliminarArchivo = (asesoria) => {
        setEliminarArchivo(asesoria);
    }

    /* Ahorros */
    const handleAgregarAhorro = (asesoria) => {
        setNuevoAhorro({ asesoria });
    }

    const handleDetallesAhorro = (ahorro) => {
        dispatch(detallesAhorro(ahorro));
    }

    const handleEditarAhorro = (ahorro) => {
        setEditarAhorroData(ahorro);
    }

    const handleEliminarAhorro = (ahorro) => {
        setEliminarAhorroData(ahorro);
    }

    /* Funciones generales */
    const handleCambioStatus = () => {
        if(indicadores_generales?.status == 0){
            if(usuario?.permisos?.asesorias?.status && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0)){
                setAsesoriaFinalizar({ id, detalles });
            }else{
                dispatch(setAlert('Necesitas permisos para esta acción', 'danger'));
            }
        }else{
            dispatch(setAlert('La asesoría ya ha finalizado', 'warning'));
        }
    }

    const handleStatus = (status) => {
        switch(status){
            case 0:
                return(
                    <Badge pill bg="warning">En curso</Badge>
                )
            case 1:
                return(
                    <Badge pill bg="success">Finalizada</Badge>
                )
            default:
                return(
                    <Badge pill bg="secondary">Sin definir</Badge>
                )
        }
    }

    useEffect(() => {
        dispatch(limpiarAsesoria());
        dispatch(limpiarContacto());
        dispatch(limpiarNota());
        dispatch(limpiarArchivo());
        dispatch(limpiarAhorro());

        return () => {
            dispatch(limpiarAsesoria());
            dispatch(limpiarContacto());
            dispatch(limpiarNota());
            dispatch(limpiarArchivo());
            dispatch(limpiarAhorro());
        }
    }, []);

    useEffect(() => {
        if(id){
            dispatch(informacionAsesoria(id));

            rutasBread[1].path = rutasBread[1].path + id;

            dispatch(editarBreadcrumb(rutasBread));
        }
    }, [id]);

    useEffect(() => {
        if(detalles){
            setAsesoriaData({
                ...asesoriaData,
                indicadores_generales: detalles.indicadores_generales, 
                informacion_asesoria: {
                    ...detalles.informacion_asesoria
                }, 
                informacion_cliente: {
                    ...detalles.informacion_cliente
                }, 
                contactos: detalles.informacion_asesoria?.historial || [],
                notas: detalles.informacion_asesoria?.notas || [],
                archivos: detalles.informacion_asesoria?.archivos || [],
                ahorros: detalles.informacion_asesoria?.ahorros || [],
                solicitud_wa: detalles.solicitud_wa || null
            });
        }
    }, [detalles]);

    useEffect(() => {
        if(detalles_archivo && detalles_archivo?.extension && detalles_archivo?.url){
            handleAbrirArchivo();
        }
    }, [detalles_archivo]);

    useEffect(() => {
        if(detalles_ahorro && detalles_ahorro?.url_comprobante && !editarAhorroData){
            window.open(detalles_ahorro.url_comprobante, '_blank', 'noopener,noreferrer');
        }
    }, [detalles_ahorro]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .btn-badge-status{
                            background-color: #fff;
                            border: none;
                            outline: none;
                            padding: 0;
                        }

                        .valor_indicador {
                            font-size: 40px;
                            margin: 0;
                        }

                        .descripcion_indicador {
                            margin: 0;
                        }

                        .chat-wa-container {
                            display: flex;
                            flex-direction: column;
                            gap: 8px;
                            max-height: 480px;
                            overflow-y: auto;
                            padding: 12px;
                            background: #ece5dd;
                            border-radius: 8px;
                        }

                        .chat-wa-row {
                            display: flex;
                        }

                        .chat-wa-row.bot {
                            justify-content: flex-start;
                        }

                        .chat-wa-row.usuario {
                            justify-content: flex-end;
                        }

                        .chat-wa-bubble {
                            max-width: 72%;
                            padding: 8px 12px;
                            border-radius: 8px;
                            font-size: 0.9rem;
                            line-height: 1.4;
                            word-break: break-word;
                            position: relative;
                        }

                        .chat-wa-row.bot .chat-wa-bubble {
                            background: #fff;
                            border-top-left-radius: 0;
                        }

                        .chat-wa-row.usuario .chat-wa-bubble {
                            background: #dcf8c6;
                            border-top-right-radius: 0;
                        }

                        .chat-wa-time {
                            font-size: 0.7rem;
                            color: #888;
                            text-align: right;
                            margin-top: 3px;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <NuevoContacto contacto={nuevoContacto} reestablecerContacto={handleAgregarContacto} />
            <NuevaNota nota={nuevaNota} reestablecerNota={handleAgregarNota} />
            <NuevoArchivo archivo={nuevoArchivo} reestablecerArchivo={handleAgregarArchivo} />
            <EditarContacto contacto={editarContacto} reestablecerContacto={handleEditarContacto} />
            <EditarNota nota={editarNota} reestablecerNota={handleEditarNota} />
            <EditarArchivo archivo={editarArchivo} reestablecerArchivo={handleEditarArchivo} />
            <EliminarContacto contacto={eliminarContacto} reestablecerContacto={handleEliminarContacto} />
            <EliminarNota nota={eliminarNota} reestablecerNota={handleEliminarNota} />
            <EliminarArchivo archivo={eliminarArchivo} reestablecerArchivo={handleEliminarArchivo} />
            <NuevoAhorro ahorro={nuevoAhorro} reestablecerAhorro={setNuevoAhorro} />
            <EditarAhorro ahorro={editarAhorroData} reestablecerAhorro={setEditarAhorroData} />
            <EliminarAhorro ahorro={eliminarAhorroData} reestablecerAhorro={setEliminarAhorroData} />
            <FinalizarAsesoria asesoria={asesoriaFinalizar} reestablecerAsesoria={setAsesoriaFinalizar} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Detalles de la asesoría</h3>
                    
                    <div className="row mb-4">
                        <div className="col-md text-center">
                            <p className="valor_indicador">{ formatNumber(contactos.length, 0, '', '') }</p>
                            <p className="descripcion_indicador">Contactos</p>
                        </div>
                        <div className="col-md text-center">
                            <p className="valor_indicador">{ formatNumber(notas.length, 0, '', '') }</p>
                            <p className="descripcion_indicador">Notas</p>
                        </div>
                        <div className="col-md text-center">
                            <p className="valor_indicador">{ formatNumber(archivos.length, 0, '', '') }</p>
                            <p className="descripcion_indicador">Archivos</p>
                        </div>
                        <div className="col-md text-center">
                            <div className="mt-2 d-flex justify-content-center">
                                <button className="btn-badge-status" onClick={() => handleCambioStatus()}>
                                    <h3 className="text-muted">
                                        { handleStatus(indicadores_generales?.status) }
                                    </h3>
                                </button>
                            </div>
                            <p className="descripcion_indicador">Estado</p>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12">
                            <div className="accordion" id="accordionDetalles">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            Información de la asesoría
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body row">
                                            <div className="col-md-12">
                                                <label className="fw-bold">Motivo</label>
                                                <p>{informacion_asesoria?.motivo || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Asesor asignado</label>
                                                <p>{informacion_asesoria?.asesor ? [informacion_asesoria?.asesor?.nombre, informacion_asesoria?.asesor?.apellido_paterno, informacion_asesoria?.asesor?.apellido_materno].join(' ') : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Fecha de inicio</label>
                                                <p>{informacion_asesoria?.creacion ? new Date(informacion_asesoria?.creacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Fecha de finalización</label>
                                                <p>{informacion_asesoria?.finalizacion ? new Date(informacion_asesoria?.finalizacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-12">
                                                <label className="fw-bold">Descripción</label>
                                                <p>{informacion_asesoria?.descripcion || 'Sin definir'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                            Información del cliente
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body row">
                                            <div className="col-md-4">
                                                <label className="fw-bold">Nombre</label>
                                                <p>{[informacion_cliente?.nombre, informacion_cliente?.apellido_paterno, informacion_cliente?.apellido_materno].join(' ')}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Celular</label>
                                                <p>{informacion_cliente?.celular ? <>{informacion_cliente.celular} <a href={`https://wa.me/${informacion_cliente.celular.replace(/\D/g, '')}`} target="_blank" rel="noreferrer"><i className="fab fa-whatsapp text-success"></i></a></> : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Email</label>
                                                <p>{informacion_cliente?.email || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Fecha de nacimiento</label>
                                                <p>{informacion_cliente?.nacimiento ? new Date(informacion_cliente?.nacimiento).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Fecha de registro</label>
                                                <p>{informacion_cliente?.creacion ? new Date(informacion_cliente?.creacion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                            </div>

                                            <hr />

                                            <div className="col-md-4">
                                                <label className="fw-bold">Nombre comercial</label>
                                                <p>{informacion_cliente?.empresa?.nombre_comercial || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Razón social</label>
                                                <p>{informacion_cliente?.empresa?.razon_social || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">RFC</label>
                                                <p>{informacion_cliente?.empresa?.rfc || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">CURP</label>
                                                <p>{informacion_cliente?.empresa?.curp || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Tipo de persona</label>
                                                <p>{informacion_cliente?.empresa?.tipo_persona || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Régimen fiscal</label>
                                                <p>{informacion_cliente?.empresa?.regimen_fiscal?.nombre || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Actividad empresarial</label>
                                                <p>{informacion_cliente?.empresa?.giro?.nombre || 'Sin definir'}</p>
                                            </div>
                                            
                                            <hr />

                                            <div className="col-md-4">
                                                <label className="fw-bold">Representante legal</label>
                                                <p>{informacion_cliente?.empresa?.representante_legal || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Puesto</label>
                                                <p>{informacion_cliente?.empresa?.puesto || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Domicilio fiscal</label>
                                                <p>{informacion_cliente?.empresa?.domicilio_fiscal || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Teléfono</label>
                                                <p>{informacion_cliente?.empresa?.telefono || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Correo</label>
                                                <p>{informacion_cliente?.empresa?.email || 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Sitio web</label>
                                                <p>{informacion_cliente?.empresa?.web ? (<a target='_blank' href={informacion_cliente?.empresa?.web}>{informacion_cliente?.empresa?.web}</a>) : ('Sin definir')}</p>
                                            </div>

                                            <hr />

                                            <div className="col-md-4">
                                                <label className="fw-bold">Fecha de constitución</label>
                                                <p>{informacion_cliente?.empresa?.fecha_constitucion ? new Date(informacion_cliente?.empresa?.fecha_constitucion).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Número de empleados</label>
                                                <p>{informacion_cliente?.empresa?.numero_empleados ? formatNumber(informacion_cliente?.empresa?.numero_empleados, 0, '', '') : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Mínimo de ingresos anuales</label>
                                                <p>{informacion_cliente?.empresa?.minimo_ingresos_anuales ? formatNumber(informacion_cliente?.empresa?.minimo_ingresos_anuales, 0, '$', '') : 'Sin definir'}</p>
                                            </div>
                                            <div className="col-md-4">
                                                <label className="fw-bold">Máximo de ingresos anuales</label>
                                                <p>{informacion_cliente?.empresa?.maximo_ingresos_anuales ? formatNumber(informacion_cliente?.empresa?.maximo_ingresos_anuales, 0, '$', '') : 'Sin definir'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {solicitud_wa &&
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingWA">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseWA" aria-expanded="false" aria-controls="collapseWA">
                                                Chat de WhatsApp
                                            </button>
                                        </h2>
                                        <div id="collapseWA" className="accordion-collapse collapse" aria-labelledby="headingWA" data-bs-parent="#accordionDetalles">
                                            <div className="accordion-body">
                                                <div className="mb-3 d-flex align-items-center gap-3">
                                                    <div>
                                                        <p className="mb-0"><strong>Nombre WA:</strong> {solicitud_wa.nombre_wa || solicitud_wa.wa_id}</p>
                                                        <p className="mb-0 text-muted" style={{ fontSize: '0.85rem' }}>
                                                            Solicitud del {solicitud_wa.fecha ? new Date(solicitud_wa.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' a las ' + new Date(solicitud_wa.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir'}
                                                        </p>
                                                    </div>
                                                    <Badge bg="success" className="ms-auto"><i className="fab fa-whatsapp me-1"></i>{solicitud_wa.contexto?.length || 0} mensajes</Badge>
                                                </div>

                                                <div className="chat-wa-container">
                                                    {(solicitud_wa.contexto || []).map((msg, i) => (
                                                        <div key={i} className={`chat-wa-row ${msg.autor}`}>
                                                            <div className="chat-wa-bubble">
                                                                {msg.body}
                                                                <div className="chat-wa-time">
                                                                    {msg.fecha ? new Date(msg.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : ''}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                            Historial de contacto
                                        </button>
                                    </h2>
                                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body row">
                                            <div className="col-md-12 text-end mb-3">
                                                {
                                                    usuario?.permisos?.asesorias?.historial?.agregar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 &&
                                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                            <button type="button" className="btn btn-primary" onClick={() => handleAgregarContacto(id)}><i className="fa-solid fa-plus"></i> Contacto</button>
                                                        </div>
                                                }
                                            </div>
                                            <DataTable
                                                columns={contactosColumnas}
                                                data={contactos}
                                                noDataComponent="No hay contactos registrados"
                                                pagination
                                                paginationPerPage={10}
                                                paginationRowsPerPageOptions={[10, 20, 50]}
                                                paginationComponentOptions={paginationOptions}
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFour">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                            Historial de notas
                                        </button>
                                    </h2>
                                    <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body">
                                            <div className="col-md-12 text-end mb-3">
                                                {
                                                    usuario?.permisos?.asesorias?.notas?.agregar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 &&
                                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                            <button type="button" className="btn btn-primary" onClick={() => handleAgregarNota(id)}><i className="fa-solid fa-plus"></i> Nota</button>
                                                        </div>
                                                }
                                            </div>
                                            <DataTable
                                                columns={notasColumnas}
                                                data={notas}
                                                noDataComponent="No hay notas registradas"
                                                pagination
                                                paginationPerPage={10}
                                                paginationRowsPerPageOptions={[10, 20, 50]}
                                                paginationComponentOptions={paginationOptions}
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingFive">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                            Expediente de archivos
                                        </button>
                                    </h2>
                                    <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body">
                                            <div className="col-md-12 text-end mb-3">
                                                {
                                                    usuario?.permisos?.asesorias?.archivos?.agregar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 &&
                                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                            <button type="button" className="btn btn-primary" onClick={() => handleAgregarArchivo(id)}><i className="fa-solid fa-plus"></i> Archivo</button>
                                                        </div>
                                                }
                                            </div>
                                            <DataTable
                                                columns={archivosColumnas}
                                                data={archivos}
                                                noDataComponent="No hay archivos registrados"
                                                pagination
                                                paginationPerPage={10}
                                                paginationRowsPerPageOptions={[10, 20, 50]}
                                                paginationComponentOptions={paginationOptions}
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingSix">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                            Ahorros generados
                                        </button>
                                    </h2>
                                    <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionDetalles">
                                        <div className="accordion-body">
                                            <div className="col-md-12 text-end mb-3">
                                                {
                                                    usuario?.permisos?.asesorias?.ahorros?.agregar && (detalles?.informacion_asesoria?.asesor?._id == usuario?._id || usuario?.tipo == 0) && indicadores_generales?.status == 0 &&
                                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                            <button type="button" className="btn btn-primary" onClick={() => handleAgregarAhorro(id)}><i className="fa-solid fa-plus"></i> Ahorro</button>
                                                        </div>
                                                }
                                            </div>
                                            <DataTable
                                                columns={ahorrosColumnas}
                                                data={ahorros}
                                                noDataComponent="Aún no hay registros"
                                                pagination
                                                paginationPerPage={10}
                                                paginationRowsPerPageOptions={[10, 20, 50]}
                                                paginationComponentOptions={paginationOptions}
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DetallesAsesoria;